import { render, staticRenderFns } from "./CreateProducerCommissionDialog.vue?vue&type=template&id=40498d58&scoped=true"
import script from "./CreateProducerCommissionDialog.vue?vue&type=script&lang=js"
export * from "./CreateProducerCommissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40498d58",
  null
  
)

export default component.exports